import React from 'react'
import type { AssignmentSpan, ScheduleColor } from './types'

interface AssignmentCellProps {
    span: AssignmentSpan
    colors: ScheduleColor
}

/** Renders a single assignment cell (filled or empty) with merged colSpan */
const AssignmentCell: React.FC<AssignmentCellProps> = ({ span, colors }) => {
    const cellColors = span.isTentative
        ? {
              bg: '#f3f4f6',
              border: '#d1d5db',
              text: '#6b7280',
          }
        : colors

    return (
        <div style={{ gridColumn: `span ${span.colSpan}` }}>
            {span.memberName ? (
                <div
                    className={`h-full px-1.5 py-0.5 min-h-[28px] flex flex-col justify-center ${
                        span.isTentative ? 'border-dashed opacity-90' : ''
                    }`}
                    style={{
                        backgroundColor: cellColors.bg,
                        borderRight: `1px ${span.isTentative ? 'dashed' : 'solid'} ${cellColors.border}`,
                        borderLeft: `1px ${span.isTentative ? 'dashed' : 'solid'} ${cellColors.border}`,
                    }}
                >
                    <div
                        className="text-[10px] truncate leading-tight font-medium"
                        style={{ color: cellColors.text }}
                    >
                        {span.memberName}
                    </div>
                    <div className="text-[9px] text-gray-600 truncate">
                        {span.timeFrom}-{span.timeTo}
                    </div>
                </div>
            ) : (
                <div className="h-full min-h-[28px] border-r" />
            )}
        </div>
    )
}

export default AssignmentCell
